import React from "react";
import BaseCard from "@/components/cards/BaseCard";

/**
 * RegionCard — for /coverage index and region hub cross-links.
 * Props: { slug, name, blurb, kind = "region" | "town", regionSlug? (for towns) }
 */
const RegionCard = ({ slug, name, blurb, kind = "region", regionSlug }) => {
  const to = `/coverage/${slug}`;
  const eyebrow = kind === "town" ? "Town" : "Region";
  return (
    <BaseCard
      to={to}
      eyebrow={eyebrow}
      title={name}
      blurb={blurb}
      testid={`region-card-${slug}`}
    />
  );
};

export default RegionCard;
